import { Store } from 'src/store/index';

const getQuantity = (store: Store) => store.design.quantity;
export default getQuantity;
